import styled from "styled-components";
import theme from "../../theme/theme";

const BodyWrapper = styled.div`
  background-color: white;
  padding: ${(props) => (props.lessPadding ? "10px" : "1.5em")};
  margin: ${(props) => `${props.isMarginNeeded ? " 1em 0.5em" : ""}`};
  border-left: ${(props) =>
    `${props.isLeftBorderVisible ? `5px solid ${theme.colors.primary}` : ""}`};
  border-radius: 5px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), -2px 0px 6px rgba(0, 0, 0, 0.25);
`;
const Card = ({
  children,
  isMarginNeeded = true,
  isLeftBorderVisible = false,
  lessPadding = false,
}) => {
  return (
    <BodyWrapper
      isMarginNeeded={isMarginNeeded}
      isLeftBorderVisible={isLeftBorderVisible}
      lessPadding={lessPadding}
    >
      {children}
    </BodyWrapper>
  );
};

export default Card;
